import { Box, Card, CardContent, DialogContent, DialogTitle, Grid, Typography } from "@mui/material"
import { DataInputDialog } from "lib/@dialogs/data-input-dialog"

import { BoundUserPhotoURLUploader } from "lib/@components/binding/bound-user-photoURL-uploader"
import { convertToLowercaseEmail } from "lib/case-helper"

import * as yup from "yup"
import { BoundTextField } from "lib/@components/binding/bound-components"

const schema = yup.object().shape({
    email: yup.string().required().email(),
    displayName: yup.string().required(),
})

function isDisabled(formData) {
    if (formData) {
        try {
            schema.validateSync(formData)
            return false
        } catch (err) {
            //
        }
    }
    return true
}

export function CreateAuthoringUserDialog({ projects }) {
    console.log({ projects })
    return (
        <DataInputDialog okLabel="Create" okCaption="Save and Invite User" okDisabled={isDisabled}>
            <DialogTitle>Add Authoring User</DialogTitle>
            <DialogContent>
                <Typography variant="body2" sx={{ marginBottom: 1 }}>
                    Add system users
                </Typography>
                <Box sx={{ flexGrow: 1 }}>
                    <Card>
                        <CardContent>
                            <Grid container direction="row" spacing={2}>
                                <Grid item xs={12} sm={7}>
                                    <BoundTextField
                                        sx={{ marginBottom: 1 }}
                                        field="email"
                                        label="Email Address *"
                                        transformOut={convertToLowercaseEmail}
                                        yup="string.trim.email.required"
                                    />
                                    <BoundTextField
                                        field="displayName"
                                        label="Name *"
                                        sx={{ marginBottom: 1 }}
                                        yup="string.trim.required"
                                    />
                                    <BoundTextField field="company" label="Company" sx={{ marginBottom: 1 }} />
                                    <BoundTextField field="jobTitle" label="Job Title" sx={{ marginBottom: 1 }} />
                                    <BoundTextField field="phone" label="Phone number" sx={{ marginBottom: 1 }} />
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <BoundUserPhotoURLUploader />
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Box>
            </DialogContent>
        </DataInputDialog>
    )
}
